import React from 'react'
import './App.css'
import {Game} from '../Game/Game'
import {Button} from '../Button/Button'
import {IRemotePlayer} from '../../types/IRemotePlayer'
import {appStorage} from '../../common'
import {playClickSound} from '../../common'
import star from './star.svg'
import {Stat} from './Stat'
import eyeOff from './eye-off.svg'
import eye from './eye.svg'
import {MuteButton} from '../MuteButton/MuteButton'

type AppProps = {
    player: IRemotePlayer
    onComplete?: Function
    onStart?: Function
    onVisitParams?: Function
    onEndBattle?: Function
    onCloseConfirm?: Function
    lang: string
}

type AppState = {
    gameStarted: boolean
    statOpened: boolean
    hideBaldaCards: boolean
    mute: boolean
    disableNewGameBtn: boolean
    showStatBtn: boolean
}

export class App extends React.Component<AppProps, AppState> {
    private readonly game: React.RefObject<Game>
    private readonly balda: IRemotePlayer

    constructor(props: AppProps) {
        super(props)
        let {mute, hideBaldaCards} = appStorage.get()

        this.state = {
            gameStarted: false,
            statOpened: false,
            hideBaldaCards: hideBaldaCards,
            mute: mute,
            disableNewGameBtn: false,
            showStatBtn: false,
        }
        this.game = React.createRef()
        this.balda = props.player
    }

    render(): JSX.Element {
        const {gameStarted, statOpened, hideBaldaCards, mute} = this.state
        const {disableNewGameBtn, showStatBtn} = this.state

        return (
            <div className="App">
                <Game
                    ref={this.game}
                    onStart={() => this.onStart()}
                    onComplete={this.props.onComplete}
                    onMove={this.balda.onMove.bind(this.balda)}
                    onVisitParams={this.props.onVisitParams}
                    onEndBattle={this.props.onEndBattle}
                    hideBaldaCards={hideBaldaCards}
                    onCloseConfirm={this.props.onCloseConfirm}
                    mute={mute}
                    lang={this.props.lang}
                />
                {gameStarted && (
                    <>
                        {showStatBtn && (
                            <Button className="App-statBtn" onClick={this.onClickStat}>
                                <img src={star} width="14px" alt="" />
                            </Button>
                        )}
                        <div className="App-rightButtons">
                            <MuteButton className="App-MuteButton" pressed={mute} onClick={this.toggleSound} />
                            <Button className="App-hideBaldaCardsBtn" onClick={this.onHideBaldaCards}>
                                <img src={hideBaldaCards ? eyeOff : eye} alt={hideBaldaCards ? 'X' : 'O'} />
                            </Button>
                            <Button
                                className="App-newGameBtn"
                                onClick={(ignored: any) => this.onClickNewGameBtn()}
                                background="#006699"
                                disabled={disableNewGameBtn}
                            >
                                {this.props.lang === 'ru' ? 'Новая игра' : 'New Game'}
                            </Button>
                        </div>
                    </>
                )}
                {statOpened && <Stat onClose={this.onCloseStat} />}
            </div>
        )
    }

    componentDidMount(): void {
        document.body.addEventListener(
            'touchmove',
            e => {
                if (!this.state.gameStarted) {
                    let elem: any = e.target

                    while (elem) {
                        if (elem.getAttribute && elem.getAttribute('data-scrollable') === 'true') {
                            return
                        }
                        elem = elem.parentNode
                    }
                }
                e.preventDefault()
            },
            {passive: false}
        )
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
        console.log('Все сломалось')
    }

    private onStart(): void {
        this.setState({gameStarted: true}, () => {
            if (this.props.onStart) {
                this.props.onStart()
            }
        })
    }

    private onClickStat = (): void => {
        this.setState({statOpened: true})
        this.playClickSound()
    }

    private async onClickNewGameBtn(): Promise<void> {
        if (!this.state.disableNewGameBtn) {
            const game = this.game.current as Game
            this.setState({disableNewGameBtn: true})
            await game.newGame()
            this.setState({disableNewGameBtn: false})
        }
    }

    private onHideBaldaCards = (): void => {
        let {hideBaldaCards} = this.state
        hideBaldaCards = !hideBaldaCards
        appStorage.upd({hideBaldaCards})
        this.setState({hideBaldaCards})
        this.playClickSound()
    }

    private toggleSound = (): void => {
        let mute = !this.state.mute
        this.setState({mute}, this.playClickSound)
        appStorage.upd({mute})
    }

    private onCloseStat = (): void => {
        this.playClickSound()
        this.setState({statOpened: false})
    }

    private playClickSound(): void {
        if (!this.state.mute) {
            playClickSound()
        }
    }
}
